import React, { useEffect, useState } from 'react'
import Slider from 'react-slick';
import { useQuery } from '@apollo/client'
import { Link } from 'react-router-dom'
import get from 'lodash/get'
import { LazyLoadImage, Pagination } from 'Blocks'
import { GET_CONTENTS, getContentsQueryVariablesForArchive } from 'Queries'
import config from 'Config'
import { PAGE_CONTEXT as p } from 'Constants'
import { path } from 'Utils';
import { Loading } from '../components'

const Archive = props => {
  const [currentScrollY, setCurrentScrollY] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  console.log(props);

  let uuids = [];
  const variables = getContentsQueryVariablesForArchive(
    '',
    uuids,
    6,
    p.Article,
    true,
    'yes',
    props.hub && props.hub.store && props.hub.store.id !== "" ? props.hub.store.id : ""
  )

  const { data, loading, error, fetchMore } = useQuery(
    GET_CONTENTS,
    {
      variables,
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    const items = get(data, 'contents.contents', [])
    if (currentScrollY && items.length > 6) {
      window.scroll(0, currentScrollY)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  if (loading) return <Loading />
  if (error) return null;
  if (data.contents.contents.length === 0) return null;

  const hasMore = get(data, 'contents.pagination.next', false)
  const items = get(data, 'contents.contents', [])
  const page = parseInt(hasMore - 1)
  const size = parseInt(6)
  const currentCount = size * page
  const totalCount = get(data, 'contents.aggregations.count', 0)

  const LoadLink = (type, uuid, slug) => {
    return path(type, { uuid, slug });
  }

  if(totalCount < 2) return null;

  const LoadSbArticles = () => {
    return (
      <div className={props.className}>
        <div className="product-journal-section">
          <div className="section-container-1140">
            <div className="product-journal-header-title">Archive</div>
              <div className="product-journal-content-row">
              {data.contents.contents && data.contents.contents.map((k) => (
                <div className="product-journal-block" key={k.uuid}>
                  <div className="product-journal-image-block">
                    <LazyLoadImage
                      alt={k.title.short}
                      width={props.screenType === 'small' ? 111 : 171}
                      height={props.screenType === 'small' ? 118 : 183}
                      image={k.image.main}
                      className="global-image"
                      useOriginal={true}
                    />
                  </div>
  
                  <div className="product-journal-content-block">
                    <div className="product-journal-content-title">{k.title.short}</div>
                    <div className="product-journal-content-description">{k.title.long}</div>
                    <div className="product-journal-link-row">
                      <Link to={LoadLink(k.type, k.uuid, k.slug)} className="content-link">Read More</Link>
                    </div>
                  </div>
                </div>
                ))}
              </div>
  
              {hasMore && (
                <div className="product-journal-loading-block">
                  <button 
                    type='button'
                    className="primary-button transparent-black"
                    onClick={() => {
                      setCurrentScrollY(window.scrollY)
                      fetchMore({
                        variables: {
                          ...variables,
                          pagination: {
                            page: data.contents.pagination.next,
                            size
                          }
                        },
                        updateQuery: (previousResult, { fetchMoreResult }) => {
                          if(!fetchMoreResult) return previousResult;
                          return fetchMoreResult;
                        }
                      })
                    }}
                  >Load More</button>
                </div>
              )}
  
          </div>
        </div>
      </div>
    )
  }

  const LoadGeneralArticles = () => {
    return (
      <div className={props.className}>
        <div className="articles-section">
          <div className="section-container">
            <div className="articles-content-row">
            {data.contents.contents && data.contents.contents.map((k) => (
              <div className="articles-block" key={`archive-article-${k.uuid}`}>
                <div className="articles-image-block">
                  <LazyLoadImage
                    alt={k.title.short}
                    width={props.screenType === 'small' ? 111 : 171}
                    height={props.screenType === 'small' ? 118 : 183}
                    image={k.image.main}
                    className="global-image"
                    useOriginal={true}
                  />
                </div>
                <div className="articles-content-block">
                  <div className="articles-block-title">{k.title.short}</div>
                  <div className="articles-block-description">{k.title.long}</div>
                  <div className="articles-block-link-row">
                    <Link to={LoadLink(k.type, k.uuid, k.slug)} className="primary-link link-black">Read More</Link>
                  </div>
                </div>
              </div>
            ))}
            </div>
            
              {props.pagination ? (
                <div className="global-pagination">
                <Pagination
                  location={props.location}
                  pagination={data.contents.pagination}
                />
                <div className="pagination-status-row">{hasMore ? currentCount : totalCount}/{totalCount} Articles</div>
                </div>
              ) : (
                hasMore && (
                  <div className="articles-section-footer-row">
                    <button 
                      type='button'
                      className="primary-button"
                      onClick={() => {
                        setCurrentScrollY(window.scrollY)
                        fetchMore({
                          variables: {
                            ...variables,
                            pagination: {
                              page: data.contents.pagination.next,
                              size
                            }
                          },
                          updateQuery: (previousResult, { fetchMoreResult }) => {
                            if(!fetchMoreResult) return previousResult;
                            return fetchMoreResult;
                          }
                        })
                      }}
                    >Discover More</button>
                  </div>
                )
              )}
          </div>
        </div>
      </div>
    )
  }

  return config.name === 'sb' ? <LoadSbArticles /> : <LoadGeneralArticles />
}

export default Archive
